import React from 'react';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';

import { processSavedReport } from 'app/area/shared/saved-reports/utils/process-saved-report';
import { SavedReportValidation } from 'app/area/shared/saved-reports/types-store';
import { OnUpdateSavedReport, UpdateSavedReportHandler } from 'app/area/shared/saved-reports/types';

import { SavedReportForm } from '../../common/components/saved-report-form';
import { validateSavedReport } from '../../common/validate-saved-report';
import { endpoints } from '../../common/endpoints';
import { SavedReportDashboard } from '../../common/types-store';
import { DashboardAdminTranslation } from '../../constants';
import { ModalSize } from 'app/components/constants';

interface SavedReportsModalProps {
  currentSavedReportId: number;
  currentSavedReport: SavedReportDashboard;
  currentSavedReportOnlyIdMode: boolean;
  allSavedReportIs: number[];

  updateCurrent: (savedReport: Partial<SavedReportDashboard>) => void;
  closeModal: () => void;

  loadEvaluation: (favouriteId: number, onUpdateSavedReport: OnUpdateSavedReport<SavedReportDashboard>) => void;

  updateSavedReport: UpdateSavedReportHandler<SavedReportDashboard>;

  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    };
  };
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;

  updateValidation: (validation: SavedReportValidation<SavedReportDashboard>) => void;
  displayError: (errorMessage: string) => void;

  locale: string;
  validation: SavedReportValidation<SavedReportDashboard>;
  translation: DashboardAdminTranslation;
}

export const SavedReportsModal: React.FC<SavedReportsModalProps> = ({
  currentSavedReportId, currentSavedReport, currentSavedReportOnlyIdMode, allSavedReportIs,
  updateCurrent, closeModal, loadEvaluation, updateSavedReport,
  options, loadOptions,
  updateValidation, displayError,
  locale, validation, translation
}) => {

  const onDone = processSavedReport({
    currentSavedReport, currentSavedReportId, allSavedReportIs, validation, translation,
    validateSavedReport, updateSavedReport, updateValidation, loadEvaluation, displayError,
    onClose: closeModal
  });

  const title = isDefinedIncludingZero(currentSavedReportId)
    ? translation.edit_connection
    : translation.add_report_by_id;

  return <ModalWrapper
    headerTitle={title}
    btnTitle={translation.done}
    btnCancelTitle={translation.cancel}
    onClose={closeModal}
    onDone={onDone}
    closeOnDone={false}
    isDisabled={!currentSavedReport?.code?.value}
    size={ModalSize.large}>
    <SavedReportForm
      savedReport={currentSavedReport}
      updateCurrent={updateCurrent}
      endpoints={endpoints}
      options={options}
      loadOptions={loadOptions}
      locale={locale}
      validation={validation}
      translation={translation} />
  </ModalWrapper>;
};
